<template>
<div style="position: relative;">
    <freeAccountMask v-if="lockedReport" :btn-text="'解鎖看更多'" style="transform: translate(-50%, calc(-50% + 20px));"/>
    <CRow>  
        <CCol>
            <CWidgetBrand
            color="greela" class="cardborder-g"
            :right-header="male_female_ratio"
            right-footer="男女比例"
            :left-header="top_Age_groups"
            left-footer="15-64歲族群中，佔比最高的年齡族群"
            :add-header-classes="blurStyle"
            >
            <CIcon
            name="cil-wc"
            height="30"
            class="my-4"/>
             <div class="DivInline" >
                    <div><h5 class="mr-1">性別年齡</h5></div>
                    <div><svg-img-icons name="questionW" width="22" height="20" v-c-tooltip="'<div class=text-left>此服務範圍內之居住人口男女比例及主要組成年齡</div>'"/></div>   
            </div>
            </CWidgetBrand>
        </CCol>  
    </CRow>
    <CRow>
        <CCol md="12">
            <ageBarChart ref="ageBarChart" :class="{'blur-style': lockedReport}" />
        </CCol> 
    </CRow>
</div>
</template>


<script>
    import { mapState } from 'vuex';
    import ageBarChart from '../components/_MarketReportResult_ageChart.vue';
    import freeAccountMask from "@/components/_MarketReportResult_freeAccountMask.vue";
    
    export default {
        name: 'consumersection',
          components: { 
            ageBarChart,
            freeAccountMask,
        },
         data(){
            return { 
               male_female_ratio:"",
               top_Age_groups:"",
            }
        },
        methods:{
            setData(data, ageData){
                //以下資料皆必須為字串型態
             
                this.male_female_ratio= data.male_female_ratio;
                this.top_Age_groups=data.top_Age_groups;

                this.$refs.ageBarChart.updateChart(ageData);
            }
        },
        computed: {
            ...mapState({
                lockedReport: (state) => state.lockedReport
            }),
            blurStyle() {
                if(this.lockedReport) {
                    return `blur-style-widget-brand`;
                }
                else {
                    return ``;
                }
            }
        }
    }
</script>

<style lang="scss">
    .blur-style-widget-brand + div {
        filter: blur(6px);
    }

    .cardborder-g:has(.blur-style-widget-brand) {
        border: none;
    }
</style>